<template>
  <v-flex>
    <proveedor-valoraciones-dialog
      v-if="proveedorPersistido"
      v-model="dialogValoraciones"
      tipo="proveedor"
      :sujeto="modelProveedor"
      @valoracion-cargada="_actualizarValoracion"
    />

    <v-dialog v-model="dialogFormularioDatosFiscales" width="1200px">
      <proveedor-datos-fiscales-formulario @cerrarFormularioDatosFiscales="dialogFormularioDatosFiscales = false"
        :modelProveedor="this.modelProveedor" :accion="'editar'" />
    </v-dialog>

    <v-card :color="'white'" class="elevation-0">
      <v-toolbar dense :color="colorBarraFormulario" dark flat>
        <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
          <span v-bind:style="{ color: 'white' }">{{ modelProveedor.nombre }}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-chip
          v-if="proveedorPersistido"
          label
          link
          class="mr-4 px-4 font-weight-bold"
          color="amber darken-2"
          text-color="blue-grey darken-4"
          @click="dialogValoraciones = true"
        >
          <v-icon left color="blue-grey darken-4">mdi-star</v-icon>
          {{ valoracionProveedorTexto }}
        </v-chip>
        <v-chip label class="mr-4 px-5" link :color="'green lighten-1'" @click="_openDatosFiscales()">
          <span v-bind:style="{ color: 'white' }">
            Datos Fiscales
          </span>
        </v-chip>
        <v-chip label class="mr-4 px-5" link :color="'green lighten-1'" @click="_openGestionCalendarioTarifas()">
          <span v-bind:style="{ color: 'white' }">
            Gestionar Precios por Fechas
          </span>
        </v-chip>
        <v-chip class="mr-4 px-10" label :color="colorAccent1" text-color="white" link
          @click="_guardarProveedor(false)">
          <span v-if="loading" v-bind:style="{ color: 'white' }">Guardando...</span>
          <span v-else v-bind:style="{ color: 'white' }">Guardar</span>
        </v-chip>
        <v-chip class="mr-4 px-10" label :color="colorAccent1" text-color="white" link @click="_guardarProveedor(true)">
          <span v-if="loading" v-bind:style="{ color: 'white' }">Guardando...</span>
          <span v-else v-bind:style="{ color: 'white' }">Guardar y Cerrar</span>
        </v-chip>
        <v-icon size="30" :color="'white'" @click="_cerrarVentana">mdi-close-circle</v-icon>
      </v-toolbar>

      <v-container class="px-4 pt-4 pb-4">
        <v-row>
          <v-col>
            <v-tabs background-color="transparent" grow v-model="tabGeneral" :slider-size="0" :slider-color="colorAccent1">
              <v-tab v-for="(header, index) in tabHeadersGeneral" :key="index" class="custom-tab"
                :class="{ 'active-tab': tabGeneral === index }">
                {{ header }}
              </v-tab>
            </v-tabs>
            <!-- DATOS GENERALES-->
            <v-tabs-items v-model="tabGeneral">
              <v-tab-item>
                <v-card>
                  <v-card-text>
                    <v-row class="mt-6">
                      <v-col>
                        <v-row dense class="mx-4">
                          <v-text-field v-model="modelProveedor.nombre_alias" outlined label="Alias" dense :dark="dark"
                            autocomplete="off" @input="modelProveedor.nombre_alias = $event.toUpperCase()"></v-text-field>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-text-field outlined v-model="modelProveedor.contacto" :dark="dark" label="Contacto" dense
                            autocomplete="off" @input="modelProveedor.contacto = $event.toUpperCase()"></v-text-field>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-text-field outlined v-model="modelProveedor.telefono" :dark="dark" label="Teléfono" dense
                            autocomplete="off" @input="modelProveedor.telefono = $event.toUpperCase()"></v-text-field>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-text-field outlined v-model="modelProveedor.email" :dark="dark" label="Email" dense
                            autocomplete="off" @input="modelProveedor.email = $event.toUpperCase()"></v-text-field>
                        </v-row>

                         <v-row dense class="mx-4">
                          <v-text-field outlined v-model="modelProveedor.email_reservas" :dark="dark" label="Email Reservas" dense
                            autocomplete="off" @input="modelProveedor.email_reservas = $event.toUpperCase()"></v-text-field>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-textarea outlined v-model="modelProveedor.observaciones" dense :dark="dark"
                            label="Observaciones"
                            @input="modelProveedor.observaciones = $event.toUpperCase()"></v-textarea>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-textarea outlined v-model="modelProveedor.condiciones_grupo" dense :dark="dark"
                            label="Condiciones del Grupo"
                            @input="modelProveedor.condiciones_grupo = $event.toUpperCase()"></v-textarea>
                        </v-row>

                        <v-row dense class="mx-4 mb-4">
                          <v-switch v-model="modelProveedor.venta_libre" hide-details dense
                            :label="`${modelProveedor.venta_libre ? ' Habilitada Venta libre' : ' Habilitada Venta libre'}`"
                            @change="_onVentaLibreChange"></v-switch>
                        </v-row>

                        <v-row v-if="modelProveedor.venta_libre" dense class="mx-4">
                          <v-text-field outlined v-model.number="modelProveedor.venta_libre_canthabitaciones"
                            :dark="dark" label="Nº Habitaciones Venta Libre" dense type="number" min="0"
                            autocomplete="off"></v-text-field>
                        </v-row>




                      </v-col>

                      <v-divider vertical></v-divider>

                      <v-col>
                        <v-card class="mx-4">
                          <v-card-title>

                          </v-card-title>

                          <v-card-text>
                            <v-row dense class="mx-4">
                              <v-text-field outlined dense :dark="dark" autocomplete="off"
                                v-model="modelProveedor.localizacion"
                                placeholder="Coordenadas (latitud, longitud) Ej. 42.88443305902265, -8.527971575319986"
                                label="Localizacion"
                                @input="modelProveedor.localizacion = $event.toUpperCase()"></v-text-field>
                            </v-row>

                            <v-row dense class="mx-4 mb-10">
                              <iframe class="mx-4"
                                :src="'https://maps.google.com/maps?q=' + modelProveedor.localizacion + '&z=12&output=embed'"
                                width="600" height="200" style="border:0;" allowfullscreen="" loading="lazy"
                                referrerpolicy="no-referrer-when-downgrade"></iframe>
                            </v-row>

                            <v-row dense class="mx-4">
                              <v-text-field outlined v-model="modelProveedor.direccion" :dark="dark" label="Dirección"
                                dense autocomplete="off" @input="modelProveedor.direccion = $event.toUpperCase()"></v-text-field>
                            </v-row>

                            <v-row dense class="mx-4">
                              <v-text-field outlined v-model="modelProveedor.cod_postal" :dark="dark"
                                label="Codigo Postal" dense autocomplete="off"
                                @input="modelProveedor.cod_postal = $event.toUpperCase()"></v-text-field>
                            </v-row>

                            <v-row dense class="mx-4">
                              <v-text-field outlined v-model="modelProveedor.poblacion" :dark="dark" label="Población"
                                dense autocomplete="off" @input="modelProveedor.poblacion = $event.toUpperCase()"></v-text-field>
                            </v-row>

                            <v-row dense class="mx-4">
                              <v-text-field outlined v-model="modelProveedor.provincia" :dark="dark" label="Provincia"
                                dense autocomplete="off" @input="modelProveedor.provincia = $event.toUpperCase()"></v-text-field>
                            </v-row>

                            <v-row dense class="mx-4">
                              <v-text-field outlined v-model="modelProveedor.pais" :dark="dark" label="País" dense
                                autocomplete="off" @input="modelProveedor.pais = $event.toUpperCase()"></v-text-field>
                            </v-row>
                          </v-card-text>
                        </v-card>



                      </v-col>
                    </v-row>

                  </v-card-text>
                </v-card>
              </v-tab-item>
            <!-- TIPOLOGIA -->
              <v-tab-item>
                <v-card>
                  <v-card-text>
                    <v-row class="mt-6">
                      <v-col>

                        <v-row dense class="mx-4 mb-4">
                          <v-select outlined dense :dark="dark" autocomplete="off"
                            v-model="modelProveedor.categoriaProveedor" label="Categoría de Proveedor"
                            :items="categoriasProveedor" return-object item-text="nombre" item-value="id"
                            @input="_actualizarCategoriaProveedor"></v-select>
                        </v-row>


                        <v-row dense class="mx-4">
                          <v-select outlined dense :dark="dark" autocomplete="off" v-model="modelProveedor.punto"
                            label="Punto de localización" :items="puntosProveedores" return-object item-text="nombre"
                            item-value="id"></v-select>
                        </v-row>






                        <v-row dense class="mx-6 mb-2"
                          v-if="modelProveedor.categoriaProveedor && modelProveedor.categoriaProveedor.nombre === 'Alojamiento'">
                          <h3>Seleccione los regimenes, tipos y características de las habitaciones disponibles del
                            alojamiento.</h3>
                        </v-row>


                        <v-row dense class="mx-4 mb-4"
                          v-if="modelProveedor.categoriaProveedor && modelProveedor.categoriaProveedor.nombre === 'Alojamiento'">
                          <v-col>
                            <v-card class="elevation-0" :color="'rgb(250, 250, 250)'">
                              <v-card-text>
                                <v-checkbox dense multiple v-for="regimen in regimenes" :key="regimen.id"
                                  v-model="regimenesSeleccionados" :label="regimen.nombre" :value="regimen.id"
                                  @change="_actualizarTarifasAutoGeneradas"></v-checkbox>
                              </v-card-text>
                            </v-card>

                          </v-col>

                          <v-divider vertical></v-divider>

                          <v-col>
                            <v-card class="elevation-0" :color="'rgb(250, 250, 250)'">
                              <v-card-text>
                                <v-checkbox dense multiple v-for="tiposHabitacion in tiposHabitacion"
                                  :key="tiposHabitacion.id" v-model="tiposHabitacionSeleccionados"
                                  :label="tiposHabitacion.nombre" :value="tiposHabitacion.id"
                                  @change="_actualizarTarifasAutoGeneradas"></v-checkbox>
                              </v-card-text>
                            </v-card>

                          </v-col>

                          <v-divider vertical></v-divider>

                          <v-col>
                            <v-card class="elevation-0" :color="'rgb(250, 250, 250)'">
                              <v-card-text>
                                <v-checkbox dense multiple v-for="caracteristica in caracteristicasHabitacion"
                                  :key="caracteristica.id" v-model="caracteristicasHabitacionSeleccionadas"
                                  :label="caracteristica.nombre" :value="caracteristica.id"
                                  @change="_actualizarTarifasAutoGeneradas"></v-checkbox>
                              </v-card-text>
                            </v-card>
                          </v-col>

                        </v-row>


                        <v-row dense class="mx-6 mt-6"
                          v-if="modelProveedor.categoriaProveedor && modelProveedor.categoriaProveedor.nombre === 'Alojamiento'">
                          <v-col>

                            <v-row dense class="mx-4">
                              <v-switch v-model="modelProveedor.ofrecen_cena" hide-details dense
                                label="Picnic"></v-switch>
                            </v-row>

                            <v-row v-if="modelProveedor.ofrecen_cena" dense class="mx-2 mb-4">
                              <v-col cols="12">
                                <v-card class="elevation-0" :color="'rgb(250, 250, 250)'">
                                  <v-card-text class="pb-2">
                                    <v-row dense>
                                      <v-col cols="12" md="4">
                                        <v-text-field outlined dense :dark="dark"
                                          v-model.number="modelProveedor.picnic_tarifa" label="Tarifa Picnic"
                                          type="number" min="0" step="0.01" autocomplete="off"></v-text-field>
                                      </v-col>

                                      <v-col cols="12">
                                        <v-textarea outlined dense :dark="dark"
                                          v-model="modelProveedor.picnic_descripcion_ES"
                                          label="Descripción Picnic ES" rows="2" auto-grow></v-textarea>
                                      </v-col>

                                      <v-col cols="12">
                                        <v-textarea outlined dense :dark="dark"
                                          v-model="modelProveedor.picnic_descripcion_EN"
                                          label="Descripción Picnic EN" rows="2" auto-grow></v-textarea>
                                      </v-col>

                                      <v-col cols="12">
                                        <v-textarea outlined dense :dark="dark"
                                          v-model="modelProveedor.picnic_descripcion_DE"
                                          label="Descripción Picnic DE" rows="2" auto-grow></v-textarea>
                                      </v-col>
                                    </v-row>
                                  </v-card-text>
                                </v-card>
                              </v-col>
                            </v-row>

                            <v-row dense class="mx-4">
                              <v-switch v-model="modelProveedor.ofrecen_cena_terceros" hide-details dense
                                label="Cena de terceros"></v-switch>
                            </v-row>

                            <v-row v-if="modelProveedor.ofrecen_cena_terceros" dense class="mx-2 mb-4">
                              <v-col cols="12">
                                <v-card class="elevation-0" :color="'rgb(250, 250, 250)'">
                                  <v-card-text class="pb-2">
                                    <v-row dense>
                                      <v-col cols="12">
                                        <v-textarea outlined dense :dark="dark"
                                          v-model="modelProveedor.cena_terceros_descripcion_ES"
                                          label="Descripción Cena de terceros ES" rows="2" auto-grow></v-textarea>
                                      </v-col>

                                      <v-col cols="12">
                                        <v-textarea outlined dense :dark="dark"
                                          v-model="modelProveedor.cena_terceros_descripcion_EN"
                                          label="Descripción Cena de terceros EN" rows="2" auto-grow></v-textarea>
                                      </v-col>

                                      <v-col cols="12">
                                        <v-textarea outlined dense :dark="dark"
                                          v-model="modelProveedor.cena_terceros_descripcion_DE"
                                          label="Descripción Cena de terceros DE" rows="2" auto-grow></v-textarea>
                                      </v-col>
                                    </v-row>
                                  </v-card-text>
                                </v-card>
                              </v-col>
                            </v-row>

                            <v-row dense class="mx-4 mb-4">
                              <v-switch v-model="modelProveedor.mascotas" hide-details dense
                                :label="`${modelProveedor.mascotas ? ' Mascotas' : ' Mascotas'}`"></v-switch>
                            </v-row>

                          </v-col>
                        </v-row>
                      </v-col>

                      <v-divider vertical></v-divider>

                      <v-col>

                        <v-data-table v-if="esCategoriaAlojamiento" locale="es" dense
                          :headers="headersTarifasAlojamiento" :items="tarifasAutoGeneradas"
                          :items-per-page="tarifasAutoGeneradas.length || 1"
                          class="elevation-1 alternating-rows bordered-table" hide-default-footer>
                          <template v-slot:top>
                            <v-toolbar dense :color="colorBarraFormulario" dark flat>
                              <v-toolbar-title>Tarifas disponibles</v-toolbar-title>
                              <v-spacer></v-spacer>
                            </v-toolbar>
                          </template>

                          <template v-slot:[`item.actions`]="{ item }">
                            <v-btn icon small color="red lighten-1" @click="_deleteTarifaAutoGenerada(item)">
                              <v-icon small>mdi-delete</v-icon>
                            </v-btn>
                          </template>

                          <template v-slot:no-data>
                            No hay tarifas disponibles
                          </template>

                        </v-data-table>

                        <v-data-table v-else-if="modelProveedor.categoriaProveedor" locale="es" dense
                          :headers="headersTarifasGenericas" :items="tarifasAutoGeneradas"
                          :items-per-page="tarifasAutoGeneradas.length || 1"
                          class="elevation-1 alternating-rows bordered-table" hide-default-footer>
                          <template v-slot:top>
                            <v-toolbar dense :color="colorBarraFormulario" dark flat>
                              <v-toolbar-title>Tarifas disponibles</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-chip small label :color="colorAccent1" text-color="white" link
                                @click="_agregarTarifaManual">
                                Agregar tarifa
                              </v-chip>
                            </v-toolbar>
                          </template>

                          <template v-slot:[`item.descripcion`]="{ item }">
                            <v-text-field v-model="item.descripcion" outlined dense hide-details class="my-2"
                              autocomplete="off" @input="item.descripcion = $event.toUpperCase()"></v-text-field>
                          </template>

                          <template v-slot:[`item.unidad`]="{ item }">
                            <v-select v-model="item.unidad" outlined dense hide-details class="my-2"
                              :items="unidadesTarifaItems" autocomplete="off"></v-select>
                          </template>

                          <template v-slot:[`item.actions`]="{ index }">
                            <v-btn icon small color="red lighten-1" @click="_deleteTarifaManual(index)">
                              <v-icon small>mdi-delete</v-icon>
                            </v-btn>
                          </template>

                          <template v-slot:no-data>
                            No hay tarifas disponibles
                          </template>

                        </v-data-table>

                        <!--    <v-row justify="center" dense class="mx-6 mt-8"
                          v-if="modelProveedor.categoriaProveedor.nombre === 'Alojamiento'">
                          <h2 class="text-center">Para agregar los precios de las tarifas debe acceder a la Gestion de Regla
                            botón, para
                            agregarlas por fechas o días de
                            la semana. </h2>
                        </v-row>

                        <v-row justify="center" dense class="mx-6 mt-8"
                          v-if="modelProveedor.categoriaProveedor.nombre === 'Alojamiento'">
                          <v-chip label class="mr-2" link :color="'green lighten-1'" @click="_openGestionCalendarioTarifas()">
                            <span v-bind:style="{ color: 'white' }">
                              Gestionar Precios por Fechas
                            </span>
                          </v-chip>
                        </v-row>

                        -->


                      </v-col>
                    </v-row>

                  </v-card-text>
                </v-card>
              </v-tab-item>
            <!-- DATOS BONO -->
              <v-tab-item>
                <v-card>
                  <v-card-text>
                    <v-row class="mt-6">
                      <v-col>
                        <v-row dense class="mx-4">
                          <v-text-field v-model="modelProveedor.alias_bono" outlined label="Alias" dense :dark="dark"
                            autocomplete="off" @input="modelProveedor.alias_bono = $event.toUpperCase()"></v-text-field>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-text-field outlined v-model="modelProveedor.direccion_bono" :dark="dark" label="Dirección" dense
                            autocomplete="off" @input="modelProveedor.direccion_bono = $event.toUpperCase()"></v-text-field>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-text-field outlined v-model="modelProveedor.cod_postal_bono" :dark="dark" label="Codigo Postal"
                            dense autocomplete="off" @input="modelProveedor.cod_postal_bono = $event.toUpperCase()"></v-text-field>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-text-field outlined v-model="modelProveedor.poblacion_bono" :dark="dark" label="Población" dense
                            autocomplete="off" @input="modelProveedor.poblacion_bono = $event.toUpperCase()"></v-text-field>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-text-field outlined v-model="modelProveedor.telefono_bono" :dark="dark" label="Teléfono" dense
                            autocomplete="off" @input="modelProveedor.telefono_bono = $event.toUpperCase()"></v-text-field>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-textarea outlined v-model="modelProveedor.observaciones_bono" :dark="dark"
                            label="Observaciones Bono" dense
                            @input="modelProveedor.observaciones_bono = $event.toUpperCase()"></v-textarea>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            <!-- OTROS CONTACTOS -->
              <v-tab-item>
                <v-card>
                  <v-card-text>
                    <v-row class="mt-6">
                      <v-col>
                        <v-row dense class="mx-4" v-if="!_getPuedeGestionarContactos()">
                          <v-col>
                            <v-alert dense outlined type="info">
                              Debe guardar el proveedor antes de gestionar otros contactos.
                            </v-alert>
                          </v-col>
                        </v-row>

                        <v-card class="mx-4 mb-4">
                          <v-toolbar dense :color="colorBarraFormulario" dark flat>
                            <v-toolbar-title>Nuevo Contacto</v-toolbar-title>
                          </v-toolbar>

                          <v-card-text class="pb-2">
                            <v-row dense>
                              <v-col cols="12" md="3">
                                <v-combobox outlined dense :dark="dark" autocomplete="off" label="Departamento"
                                  v-model="modelContactoNuevo.departamento"
                                  :items="departamentosContactoItems"
                                  :disabled="loadingCreandoContacto || !_getPuedeGestionarContactos()"></v-combobox>
                              </v-col>

                              <v-col cols="12" md="3">
                                <v-text-field outlined dense :dark="dark" autocomplete="off" label="Responsable"
                                  v-model="modelContactoNuevo.responsable"
                                  :disabled="loadingCreandoContacto || !_getPuedeGestionarContactos()"
                                  @input="modelContactoNuevo.responsable = $event.toUpperCase()"></v-text-field>
                              </v-col>

                              <v-col cols="12" md="3">
                                <v-text-field outlined dense :dark="dark" autocomplete="off" label="Teléfono"
                                  v-model="modelContactoNuevo.telefono"
                                  :disabled="loadingCreandoContacto || !_getPuedeGestionarContactos()"
                                  @input="modelContactoNuevo.telefono = $event.toUpperCase()"></v-text-field>
                              </v-col>

                              <v-col cols="12" md="3">
                                <v-text-field outlined dense :dark="dark" autocomplete="off" label="Email"
                                  v-model="modelContactoNuevo.email"
                                  :disabled="loadingCreandoContacto || !_getPuedeGestionarContactos()"
                                  @input="modelContactoNuevo.email = $event.toUpperCase()"></v-text-field>
                              </v-col>
                            </v-row>
                          </v-card-text>

                          <v-card-actions class="px-4 pb-4">
                            <v-spacer></v-spacer>
                            <v-chip label class="mr-2 px-6" :color="'blue-grey lighten-1'" text-color="white" link
                              :disabled="loadingCreandoContacto || !_getPuedeGestionarContactos()"
                              @click="_resetContactoNuevo">
                              Limpiar
                            </v-chip>
                            <v-chip label class="px-6" :color="colorAccent1" text-color="white" link
                              :disabled="loadingCreandoContacto || !_getPuedeGestionarContactos()"
                              @click="_crearContactoProveedor">
                              {{ loadingCreandoContacto ? 'Creando...' : 'Crear contacto' }}
                            </v-chip>
                          </v-card-actions>
                        </v-card>

                        <v-row dense class="mx-2" v-if="!modelProveedor.contactos || modelProveedor.contactos.length === 0">
                          <v-col>
                            <v-alert dense outlined type="info">
                              No hay otros contactos registrados para este proveedor.
                            </v-alert>
                          </v-col>
                        </v-row>

                        <v-row dense class="mx-2">
                          <v-col cols="12" md="6" lg="4" v-for="(contacto, index) in modelProveedor.contactos"
                            :key="contacto.id || index">
                            <v-card class="elevation-1">
                              <v-card-title class="pb-0">
                                <span class="text-subtitle-1">{{ contacto.departamento }}</span>
                              </v-card-title>

                              <v-card-text class="pb-2 mt-4">
                                <v-row dense>
                                  <v-col cols="12">
                                    <v-combobox outlined dense :dark="dark" autocomplete="off" label="Departamento"
                                      v-model="contacto.departamento"
                                      :items="departamentosContactoItems"
                                      :disabled="contactoSavingId === contacto.id || contactoDeletingId === contacto.id || !_getPuedeGestionarContactos()"></v-combobox>
                                  </v-col>
                                  <v-col cols="12">
                                    <v-text-field outlined dense :dark="dark" autocomplete="off" label="Responsable"
                                      v-model="contacto.responsable"
                                      :disabled="contactoSavingId === contacto.id || contactoDeletingId === contacto.id || !_getPuedeGestionarContactos()"
                                      @input="contacto.responsable = $event.toUpperCase()"></v-text-field>
                                  </v-col>
                                  <v-col cols="12">
                                    <v-text-field outlined dense :dark="dark" autocomplete="off" label="Teléfono"
                                      v-model="contacto.telefono"
                                      :disabled="contactoSavingId === contacto.id || contactoDeletingId === contacto.id || !_getPuedeGestionarContactos()"
                                      @input="contacto.telefono = $event.toUpperCase()"></v-text-field>
                                  </v-col>
                                  <v-col cols="12">
                                    <v-text-field outlined dense :dark="dark" autocomplete="off" label="Email"
                                      v-model="contacto.email"
                                      :disabled="contactoSavingId === contacto.id || contactoDeletingId === contacto.id || !_getPuedeGestionarContactos()"
                                      @input="contacto.email = $event.toUpperCase()"></v-text-field>
                                  </v-col>
                                </v-row>
                              </v-card-text>

                              <v-card-actions class="px-4 pb-4">
                                <v-spacer></v-spacer>
                                <v-chip label class="mr-2 px-6" :color="'red lighten-1'" text-color="white" link
                                  :disabled="contactoSavingId === contacto.id || contactoDeletingId === contacto.id || !_getPuedeGestionarContactos()"
                                  @click="_eliminarContactoProveedor(contacto, index)">
                                  {{ contactoDeletingId === contacto.id ? 'Eliminando...' : 'Eliminar' }}
                                </v-chip>
                                <v-chip label class="px-6" :color="colorAccent1" text-color="white" link
                                  :disabled="contactoSavingId === contacto.id || contactoDeletingId === contacto.id || !_getPuedeGestionarContactos()"
                                  @click="_actualizarContactoProveedor(contacto, index)">
                                  {{ contactoSavingId === contacto.id ? 'Guardando...' : 'Guardar' }}
                                </v-chip>
                              </v-card-actions>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            <!-- DOCUMENTOS -->
              <v-tab-item>
                <v-card>
                  <v-card-text>
                    <v-row class="mt-6">
                      <v-col>
                        <v-row dense class="mx-4" v-if="!_getPuedeGestionarDocumentos()">
                          <v-col>
                            <v-alert dense outlined type="info">
                              Debe guardar el proveedor antes de gestionar documentos.
                            </v-alert>
                          </v-col>
                        </v-row>

                        <v-card class="mx-4 mb-4">
                          <v-toolbar dense :color="colorBarraFormulario" dark flat>
                            <v-toolbar-title>Nuevo Documento</v-toolbar-title>
                          </v-toolbar>

                          <v-card-text class="pb-2">
                            <v-row dense>
                              <v-col cols="12" md="4">
                                <v-text-field outlined dense :dark="dark" autocomplete="off" label="Nombre"
                                  v-model="modelDocumentoNuevo.nombre"
                                  :disabled="loadingCreandoDocumento || !_getPuedeGestionarDocumentos()"
                                  @input="modelDocumentoNuevo.nombre = $event.toUpperCase()"></v-text-field>
                              </v-col>

                              <v-col cols="12" md="8">
                                <input
                                  ref="inputDocumentoNuevo"
                                  class="d-none"
                                  type="file"
                                  accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx"
                                  :disabled="loadingCreandoDocumento || !_getPuedeGestionarDocumentos()"
                                  @change="_onArchivoDocumentoNuevoChange"
                                />

                                <v-chip
                                  label
                                  class="px-6"
                                  :color="colorAccent1"
                                  text-color="white"
                                  link
                                  :disabled="loadingCreandoDocumento || !_getPuedeGestionarDocumentos()"
                                  @click="_abrirSelectorDocumentoNuevo"
                                >
                                  Subir documento
                                </v-chip>

                                <div v-if="modelDocumentoNuevo.archivo" class="mt-2 d-flex align-center">
                                  <v-icon small class="mr-2">mdi-file-document-outline</v-icon>
                                  <span>{{ modelDocumentoNuevo.archivo.name }}</span>
                                </div>
                              </v-col>
                            </v-row>
                          </v-card-text>

                          <v-card-actions class="px-4 pb-4">
                            <v-spacer></v-spacer>
                            <v-chip label class="mr-2 px-6" :color="'blue-grey lighten-1'" text-color="white" link
                              :disabled="loadingCreandoDocumento || !_getPuedeGestionarDocumentos()"
                              @click="_resetDocumentoNuevo">
                              Limpiar
                            </v-chip>
                            <v-chip label class="px-6" :color="colorAccent1" text-color="white" link
                              :disabled="loadingCreandoDocumento || !_getPuedeGestionarDocumentos()"
                              @click="_crearDocumentoProveedor">
                              {{ loadingCreandoDocumento ? 'Creando...' : 'Crear documento' }}
                            </v-chip>
                          </v-card-actions>
                        </v-card>

                        <v-row dense class="mx-2" v-if="!documentosProveedor || documentosProveedor.length === 0">
                          <v-col>
                            <v-alert dense outlined type="info">
                              No hay documentos registrados para este proveedor.
                            </v-alert>
                          </v-col>
                        </v-row>

                        <v-row dense class="mx-2" v-else>
                          <v-col cols="12">
                            <v-data-table locale="es" dense :headers="headersDocumentosProveedor" :items="documentosProveedor"
                              :items-per-page="documentosProveedor.length || 1"
                              class="elevation-1 alternating-rows bordered-table" hide-default-footer>
                              <template v-slot:[`item.id`]="{ item }">
                                <span>{{ item.id != null ? item.id : '-' }}</span>
                              </template>

                              <template v-slot:[`item.nombre`]="{ item }">
                                <span>{{ item.nombre || '-' }}</span>
                              </template>

                              <template v-slot:[`item.archivo`]="{ item }">
                                <span v-if="item.url" class="d-inline-flex align-center">
                                  <v-icon small class="mr-2">mdi-file-document-outline</v-icon>
                                  {{ _getNombreArchivoDocumento(item.url) }}
                                </span>
                                <span v-else>-</span>
                              </template>

                              <template v-slot:[`item.actions`]="{ item, index }">
                                <v-chip label small class="mr-2" :color="'blue-grey darken-2'" text-color="white" link
                                  :disabled="documentoDeletingId === item.id || !_getPuedeGestionarDocumentos() || !_construirUrlDocumentoBackend(item.url)"
                                  @click="_abrirDocumentoProveedor(item)">
                                  Abrir
                                </v-chip>
                                <v-chip label small :color="'red lighten-1'" text-color="white" link
                                  :disabled="documentoDeletingId === item.id || !_getPuedeGestionarDocumentos()"
                                  @click="_eliminarDocumentoProveedor(item, index)">
                                  {{ documentoDeletingId === item.id ? 'Eliminando...' : 'Eliminar' }}
                                </v-chip>
                              </template>
                            </v-data-table>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>

          </v-col>
        </v-row>

      </v-container>

    </v-card>
  </v-flex>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import ProveedorDatosFiscalesFormulario from "../formularios/ProveedorDatosFiscalesFormulario";
import ProveedorValoracionesDialog from "../valoraciones/ProveedorValoracionesDialog";


export default {
  name: "ProveedorFormulario",
  components: {
    ProveedorDatosFiscalesFormulario,
    ProveedorValoracionesDialog,
  },
  data: () => ({
    loading: false,

    tabDirecciones: null,
    tabHeadersDirecciones: ['Direccion', 'DireccionFiscal'],

    tabGeneral: null, // Para controlar el tab activo
    tabHeadersGeneral: ['DATOS GENERALES', 'TIPOLOGÍA', 'DATOS BONO', 'OTROS CONTACTOS', 'DOCUMENTOS'],

    headersTarifasAlojamiento: [
      { text: 'REGIMEN', value: 'regimen_titulo' },
      { text: 'HABITACION-CARACTERISTICA', value: 'habitacion_caracteristica_titulo' },
      { text: '', value: 'actions', align: 'end', width: '100px' },
    ],

    headersTarifasGenericas: [
      { text: 'DESCRIPCION', value: 'descripcion' },
      { text: 'UNIDAD', value: 'unidad', width: '200px' },
      { text: '', value: 'actions', align: 'end', width: '100px' },
    ],

    headersDocumentosProveedor: [
      { text: 'ID', value: 'id', width: '120px' },
      { text: 'NOMBRE', value: 'nombre' },
      { text: 'ARCHIVO', value: 'archivo' },
      { text: '', value: 'actions', align: 'end', width: '220px' },
    ],

    tiposSeleccionados: [],

    regimenesSeleccionados: [],
    tiposHabitacionSeleccionados: [],
    caracteristicasHabitacionSeleccionadas: [],

    tarifasAutoGeneradas: [],

    dialogFormularioCalendarioTarifas: false,
    dialogFormularioDatosFiscales: false,
    dialogValoraciones: false,

    modelContactoNuevo: {
      departamento: null,
      responsable: null,
      telefono: null,
      email: null,
    },
    loadingCreandoContacto: false,
    contactoSavingId: null,
    contactoDeletingId: null,
    departamentosContactoItems: ["Administracion", "Reservas", "Grupos", "Recepcion"],
    unidadesTarifaItems: ["x_Reserva", "x_Persona"],

    modelDocumentoNuevo: {
      nombre: null,
      archivo: null,
    },
    documentosProveedorLocal: [],
    loadingCreandoDocumento: false,
    documentoDeletingId: null,
    extensionesDocumentoPermitidas: ["pdf", "jpg", "jpeg", "png", "doc", "docx", "xls", "xlsx"],
    maxDocumentoBytes: 20 * 1024 * 1024,


  }),

  props: {
    modelProveedor: {
      type: Object,
      required: true,
    },

    accion: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapState([
      "drawer",
      "dark",
      "colorAccent1",
      "colorAccent2",
      "colorAccent3",
      "colorBarraFormulario",
      "colorFondoDialog",
      "tiposProveedor",

    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),
    ...mapState("proveedores", [
      "regimenes",
      "categoriasProveedor",
      "tiposHabitacion",
      "caracteristicasHabitacion",
      "puntosProveedores",
    ]),

    esCategoriaAlojamiento() {
      return !!(
        this.modelProveedor &&
        this.modelProveedor.categoriaProveedor &&
        this.modelProveedor.categoriaProveedor.nombre === "Alojamiento"
      );
    },

    documentosProveedor() {
      return Array.isArray(this.documentosProveedorLocal) ? this.documentosProveedorLocal : [];
    },

    proveedorPersistido() {
      return !!this.modelProveedor?.id;
    },

    valoracionProveedorTexto() {
      if (this.modelProveedor.valoracion === null || this.modelProveedor.valoracion === undefined) {
        return "Sin valorar";
      }

      return `${Number(this.modelProveedor.valoracion).toFixed(1).replace(".", ",")} / 10`;
    },



  },

  watch: {
    modelProveedor(newVal) {
      this._inicializarCamposProveedor();
      this._normalizarCamposVentaLibre();
      this._inicializarContactos();
      this._inicializarDocumentosProveedor();
      this.regimenesSeleccionados = this.modelProveedor.regimenes && this.modelProveedor.regimenes.length > 0 ? this.modelProveedor.regimenes.map(regimen => regimen.id) : [];
      this.tiposHabitacionSeleccionados = this.modelProveedor.tipoHabitaciones && this.modelProveedor.tipoHabitaciones.length > 0 ? this.modelProveedor.tipoHabitaciones.map(tiposHabitacion => tiposHabitacion.id) : [];
      this.caracteristicasHabitacionSeleccionadas = this.modelProveedor.caracteristicasHabitaciones && this.modelProveedor.caracteristicasHabitaciones.length > 0 ? this.modelProveedor.caracteristicasHabitaciones.map(caracteristica => caracteristica.id) : [];
      this._inicializarTarifasProveedor();
    }
  },

  mounted() {
    this._inicializarCamposProveedor();
    this._normalizarCamposVentaLibre();
    this._inicializarContactos();
    this._inicializarDocumentosProveedor();
    this.regimenesSeleccionados = this.modelProveedor.regimenes && this.modelProveedor.regimenes.length > 0 ? this.modelProveedor.regimenes.map(regimen => regimen.id) : [];
    this.tiposHabitacionSeleccionados = this.modelProveedor.tipoHabitaciones && this.modelProveedor.tipoHabitaciones.length > 0 ? this.modelProveedor.tipoHabitaciones.map(tiposHabitacion => tiposHabitacion.id) : [];
    this.caracteristicasHabitacionSeleccionadas = this.modelProveedor.caracteristicasHabitaciones && this.modelProveedor.caracteristicasHabitaciones.length > 0 ? this.modelProveedor.caracteristicasHabitaciones.map(caracteristica => caracteristica.id) : [];
    this._inicializarTarifasProveedor();
  },

  methods: {
    ...mapMutations("proveedores", ["setProveedorSelec"]),
    ...mapActions("proveedores", [
      "getProveedor",
      "getProveedores",
      "crearProveedor",
      "updateProveedor",
      "crearProveedorContacto",
      "updateProveedorContacto",
      "eliminarProveedorContacto",
      "crearProveedorDocumento",
      "eliminarProveedorDocumento",
    ]),
    ...mapActions("puntos", ["getPuntos"]),

    _cerrarVentana() {
      this.$emit("cerrarFormularioProveedor");
    },

    _actualizarValoracion(valoracion) {
      this.$set(this.modelProveedor, "valoracion", valoracion);
    },

    _actualizarCategoriaProveedor(value) {
      if (!value) {
        this.tarifasAutoGeneradas = [];
        return;
      }

      if (value.nombre !== 'Alojamiento') {
        this.regimenesSeleccionados = [];
        this.tiposHabitacionSeleccionados = [];
        this.caracteristicasHabitacionSeleccionadas = [];
        this.tarifasAutoGeneradas = this.tarifasAutoGeneradas.some(tarifa => this._esTarifaAlojamiento(tarifa))
          ? []
          : this.tarifasAutoGeneradas.map(tarifa => this._normalizarTarifaManual(tarifa));
        return;
      }

      if (this.tarifasAutoGeneradas.some(tarifa => !this._esTarifaAlojamiento(tarifa))) {
        this.tarifasAutoGeneradas = [];
      }
    },

    _openDatosFiscales() {
      this.dialogFormularioDatosFiscales = true;
    },

    _guardarTarifasAutogeneradas() {
      this.dialogFormularioCalendarioTarifas = true;
    },

    _actualizarTarifasAutoGeneradas() {
      this.tarifasAutoGeneradas = [];

      this.regimenesSeleccionados.sort((a, b) => a - b);
      this.tiposHabitacionSeleccionados.sort((a, b) => a - b);
      this.caracteristicasHabitacionSeleccionadas.sort((a, b) => a - b);

      this.regimenesSeleccionados.forEach(regimen => {
        this.caracteristicasHabitacionSeleccionadas.forEach(caracteristica => {
          this.tiposHabitacionSeleccionados.forEach(tipoHabitacion => {

            let regimen_titulo = this.regimenes.find(reg => reg.id === regimen).nombre;
            let tipoHabitacionNombre = this.tiposHabitacion.find(tipo => tipo.id === tipoHabitacion).nombre;
            let caracteristicaNombre = this.caracteristicasHabitacion.find(caract => caract.id === caracteristica).nombre;

            let habitacion_caracteristica_titulo = tipoHabitacionNombre + " - " + caracteristicaNombre;

            if (caracteristicaNombre === 'Estandar') {
              habitacion_caracteristica_titulo = tipoHabitacionNombre;
            }

            this.tarifasAutoGeneradas.push({
              proveedor_id: this.modelProveedor.id,
              regimen_id: regimen,
              tipo_habitacion_id: tipoHabitacion,
              caracteristica_habitacion_id: caracteristica,
              regimen_titulo: regimen_titulo,
              habitacion_caracteristica_titulo: habitacion_caracteristica_titulo,
            });

          });
        });
      });
    },

    _inicializarTarifasProveedor() {
      const tarifasProveedor = Array.isArray(this.modelProveedor.tarifas) ? this.modelProveedor.tarifas : [];
      if (this.esCategoriaAlojamiento) {
        this.tarifasAutoGeneradas = tarifasProveedor;
        return;
      }

      this.tarifasAutoGeneradas = tarifasProveedor
        .filter(tarifa => !this._esTarifaAlojamiento(tarifa) || tarifa.descripcion || tarifa.unidad)
        .map(tarifa => this._normalizarTarifaManual(tarifa));
    },

    _esTarifaAlojamiento(tarifa = {}) {
      return !!(
        tarifa.regimen_id ||
        tarifa.tipo_habitacion_id ||
        tarifa.caracteristica_habitacion_id ||
        tarifa.regimen_titulo ||
        tarifa.habitacion_caracteristica_titulo
      );
    },

    _normalizarTarifaManual(tarifa = {}) {
      return {
        ...tarifa,
        proveedor_id: tarifa.proveedor_id || this.modelProveedor.id || null,
        descripcion: tarifa.descripcion != null ? tarifa.descripcion : "",
        unidad: tarifa.unidad != null ? tarifa.unidad : "",
      };
    },

    _agregarTarifaManual() {
      this.tarifasAutoGeneradas.push(this._normalizarTarifaManual());
    },

    _openGestionCalendarioTarifas() {
      this.setProveedorSelec(JSON.parse(JSON.stringify(this.modelProveedor)));
      this.$router.push({ name: 'ProveedoresReglasTarifas' });
    },

    _deleteTarifaAutoGenerada(tarifa) {
      this.tarifasAutoGeneradas = this.tarifasAutoGeneradas.filter(t => t.regimen_id !== tarifa.regimen_id ||
        t.tipo_habitacion_id !== tarifa.tipo_habitacion_id ||
        t.caracteristica_habitacion_id !== tarifa.caracteristica_habitacion_id);
    },

    _deleteTarifaManual(index) {
      this.tarifasAutoGeneradas.splice(index, 1);
    },

    _onVentaLibreChange(value) {
      if (!value) {
        this.modelProveedor.venta_libre_canthabitaciones = null;
      }
    },

    _inicializarCamposProveedor() {
      const defaults = {
        alias_bono: null,
        direccion_bono: null,
        observaciones_bono: null,
        cod_postal_bono: null,
        poblacion_bono: null,
        telefono_bono: null,
        deshabilitado: false,
        comisiones_iva_incluido: false,
        retener_irpf: false,
        ofrecen_cena: false,
        ofrecen_cena_terceros: false,
        mascotas: false,
        picnic_tarifa: null,
        picnic_descripcion_ES: null,
        picnic_descripcion_EN: null,
        picnic_descripcion_DE: null,
        cena_terceros_descripcion_ES: null,
        cena_terceros_descripcion_EN: null,
        cena_terceros_descripcion_DE: null,
      };

      Object.entries(defaults).forEach(([field, defaultValue]) => {
        if (!Object.prototype.hasOwnProperty.call(this.modelProveedor, field)) {
          this.$set(this.modelProveedor, field, defaultValue);
        }
      });

      this.modelProveedor.ofrecen_cena = this._normalizarBoolean(this.modelProveedor.ofrecen_cena);
      this.modelProveedor.ofrecen_cena_terceros = this._normalizarBoolean(this.modelProveedor.ofrecen_cena_terceros);
      this.modelProveedor.mascotas = this._normalizarBoolean(this.modelProveedor.mascotas);
      this.modelProveedor.deshabilitado = this._normalizarBoolean(this.modelProveedor.deshabilitado);
      this.modelProveedor.comisiones_iva_incluido = this._normalizarBoolean(this.modelProveedor.comisiones_iva_incluido);
      this.modelProveedor.retener_irpf = this._normalizarBoolean(this.modelProveedor.retener_irpf);
    },

    _normalizarBoolean(value) {
      if (value === 1 || value === "1") {
        return true;
      }

      if (value === 0 || value === "0") {
        return false;
      }

      return !!value;
    },

    _normalizarCamposVentaLibre() {
      if (this.modelProveedor.venta_libre === 1 || this.modelProveedor.venta_libre === 0) {
        this.modelProveedor.venta_libre = this.modelProveedor.venta_libre === 1;
      } else {
        this.modelProveedor.venta_libre = !!this.modelProveedor.venta_libre;
      }
    },

    _inicializarContactos() {
      if (!Array.isArray(this.modelProveedor.contactos)) {
        this.$set(this.modelProveedor, "contactos", []);
      }
      this.modelProveedor.contactos = this.modelProveedor.contactos.map(contacto => this._normalizarContacto(contacto));
    },

    _normalizarContacto(contacto = {}) {
      return {
        ...contacto,
        departamento: contacto.departamento != null ? contacto.departamento : null,
        responsable: contacto.responsable != null ? contacto.responsable : null,
        telefono: contacto.telefono != null ? contacto.telefono : null,
        email: contacto.email != null ? contacto.email : null,
      };
    },

    _getPuedeGestionarContactos() {
      return this.proveedorPersistido;
    },

    _getDocumentosProveedorRaw() {
      return this.modelProveedor?.documentos
        || this.modelProveedor?.documentos_proveedor
        || this.modelProveedor?.docs
        || [];
    },

    _normalizarDocumentoProveedor(documento = {}) {
      return {
        id: documento?.id ?? null,
        proveedor_id: documento?.proveedor_id ?? this.modelProveedor?.id ?? null,
        nombre: documento?.nombre || documento?.name || documento?.titulo || documento?.documento || "",
        url: documento?.url || documento?.file_url || documento?.enlace || "",
      };
    },

    _inicializarDocumentosProveedor() {
      const documentos = this._getDocumentosProveedorRaw();
      this.documentosProveedorLocal = (Array.isArray(documentos) ? documentos : []).map((documento) =>
        this._normalizarDocumentoProveedor(documento)
      );
    },

    _getPuedeGestionarDocumentos() {
      return this.proveedorPersistido;
    },

    _getBaseUrlBackend() {
      const baseURL = this.axios?.defaults?.baseURL || this.$http?.defaults?.baseURL || "";
      return String(baseURL || "").replace(/\/api\/v1\/?$/i, "");
    },

    _construirUrlDocumentoBackend(url) {
      const rawUrl = String(url || "").trim();
      if (!rawUrl) {
        return "";
      }

      if (/^https?:\/\//i.test(rawUrl)) {
        return rawUrl;
      }

      const baseBackend = this._getBaseUrlBackend();
      if (!baseBackend) {
        return rawUrl;
      }

      return `${baseBackend}${rawUrl.startsWith("/") ? "" : "/"}${rawUrl}`;
    },

    _getNombreArchivoDocumento(url) {
      const normalizada = String(url || "").replace(/\\/g, "/");
      if (!normalizada) {
        return "";
      }

      const partes = normalizada.split("/");
      return partes[partes.length - 1] || normalizada;
    },

    _abrirDocumentoProveedor(documento) {
      const urlDocumento = this._construirUrlDocumentoBackend(documento?.url);
      if (!urlDocumento) {
        return;
      }

      window.open(urlDocumento, "_blank", "noopener,noreferrer");
    },

    _abrirSelectorDocumentoNuevo() {
      if (!this._getPuedeGestionarDocumentos() || this.loadingCreandoDocumento) {
        return;
      }

      if (this.$refs.inputDocumentoNuevo) {
        this.$refs.inputDocumentoNuevo.click();
      }
    },

    _onArchivoDocumentoNuevoChange(event) {
      const file = event?.target?.files && event.target.files[0] ? event.target.files[0] : null;
      this.$set(this.modelDocumentoNuevo, "archivo", file);
    },

    _resetDocumentoNuevo() {
      this.modelDocumentoNuevo = {
        nombre: null,
        archivo: null,
      };

      if (this.$refs.inputDocumentoNuevo) {
        this.$refs.inputDocumentoNuevo.value = null;
      }
    },

    _validarArchivoDocumento(archivo) {
      if (!archivo) {
        return false;
      }

      if (archivo.size > this.maxDocumentoBytes) {
        console.error("El archivo supera el máximo permitido de 20MB.");
        return false;
      }

      const extension = String(archivo.name || "").split(".").pop()?.toLowerCase() || "";
      if (!this.extensionesDocumentoPermitidas.includes(extension)) {
        console.error("Extensión de archivo no permitida para documentos.");
        return false;
      }

      return true;
    },

    async _refrescarProveedorDocumentos() {
      if (!this.modelProveedor?.id || !this.access_token) {
        return;
      }

      const proveedorActualizado = await this.getProveedor([
        this.access_token,
        this.modelProveedor.id,
        false,
      ]);

      if (!proveedorActualizado) {
        return;
      }

      const documentosActualizados = proveedorActualizado.documentos
        || proveedorActualizado.documentos_proveedor
        || proveedorActualizado.docs
        || [];

      this.$set(this.modelProveedor, "documentos", documentosActualizados);
      this._inicializarDocumentosProveedor();
    },

    async _crearDocumentoProveedor() {
      if (!this._getPuedeGestionarDocumentos() || this.loadingCreandoDocumento) {
        return;
      }

      if (!this._validarArchivoDocumento(this.modelDocumentoNuevo.archivo)) {
        return;
      }

      this.loadingCreandoDocumento = true;
      try {
        const res = await this.crearProveedorDocumento([
          this.access_token,
          this.modelProveedor.id,
          {
            nombre: this.modelDocumentoNuevo.nombre,
            archivo: this.modelDocumentoNuevo.archivo,
          },
        ]);
        if (res && res.documento) {
          await this._refrescarProveedorDocumentos();
          this._resetDocumentoNuevo();
        }
      } finally {
        this.loadingCreandoDocumento = false;
      }
    },

    async _eliminarDocumentoProveedor(documento, index) {
      if (!this._getPuedeGestionarDocumentos() || !documento || !documento.id) {
        return;
      }

      this.documentoDeletingId = documento.id;
      try {
        const res = await this.eliminarProveedorDocumento([
          this.access_token,
          this.modelProveedor.id,
          documento.id,
        ]);
        if (res && res.documento) {
          await this._refrescarProveedorDocumentos();
        } else if (index >= 0) {
          this.documentosProveedorLocal.splice(index, 1);
        }
      } finally {
        this.documentoDeletingId = null;
      }
    },

    _resetContactoNuevo() {
      this.modelContactoNuevo = {
        departamento: null,
        responsable: null,
        telefono: null,
        email: null,
      };
    },

    async _crearContactoProveedor() {
      if (!this._getPuedeGestionarContactos() || this.loadingCreandoContacto) {
        return;
      }
      this.loadingCreandoContacto = true;
      const modelContacto = this._normalizarContacto(this.modelContactoNuevo);
      const res = await this.crearProveedorContacto([
        this.access_token,
        this.modelProveedor.id,
        modelContacto,
      ]);
      if (res && res.contacto) {
        this.modelProveedor.contactos.push(this._normalizarContacto(res.contacto));
        this._resetContactoNuevo();
      }
      this.loadingCreandoContacto = false;
    },

    async _actualizarContactoProveedor(contacto, index) {
      if (!this._getPuedeGestionarContactos() || !contacto || !contacto.id) {
        return;
      }
      this.contactoSavingId = contacto.id;
      const modelContacto = this._normalizarContacto(contacto);
      const res = await this.updateProveedorContacto([
        this.access_token,
        this.modelProveedor.id,
        contacto.id,
        modelContacto,
      ]);
      if (res && res.contacto) {
        this.$set(this.modelProveedor.contactos, index, this._normalizarContacto(res.contacto));
      }
      this.contactoSavingId = null;
    },

    async _eliminarContactoProveedor(contacto, index) {
      if (!this._getPuedeGestionarContactos() || !contacto || !contacto.id) {
        return;
      }
      this.contactoDeletingId = contacto.id;
      const res = await this.eliminarProveedorContacto([
        this.access_token,
        this.modelProveedor.id,
        contacto.id,
      ]);
      if (res) {
        this.modelProveedor.contactos.splice(index, 1);
      }
      this.contactoDeletingId = null;
    },

    async _guardarProveedor(cerrar) {
      if (this.loading) {
        return;
      }

      this.loading = true;

      try {
        const cantidadHabitaciones = parseInt(this.modelProveedor.venta_libre_canthabitaciones, 10);
        const picnicTarifa = this.modelProveedor.picnic_tarifa === "" || this.modelProveedor.picnic_tarifa == null
          ? null
          : Number(this.modelProveedor.picnic_tarifa);
        const tarifasPayload = this.esCategoriaAlojamiento
          ? this.tarifasAutoGeneradas
          : this.tarifasAutoGeneradas
            .map(tarifa => ({
              ...tarifa,
              descripcion: tarifa.descripcion != null ? tarifa.descripcion.trim() : "",
              unidad: tarifa.unidad != null ? tarifa.unidad.trim() : "",
            }))
            .filter(tarifa => tarifa.descripcion || tarifa.unidad);
        const modelProveedorPayload = {
          ...this.modelProveedor,
          categoria_proveedor_id: this.modelProveedor.categoriaProveedor ? this.modelProveedor.categoriaProveedor.id : null,
          punto_id: this.modelProveedor.punto ? this.modelProveedor.punto.id : null,
          deshabilitado: this.modelProveedor.deshabilitado ? 1 : 0,
          comisiones_iva_incluido: this.modelProveedor.comisiones_iva_incluido ? 1 : 0,
          retener_irpf: this.modelProveedor.retener_irpf ? 1 : 0,
          venta_libre: this.modelProveedor.venta_libre ? 1 : 0,
          ofrecen_cena: this.modelProveedor.ofrecen_cena ? 1 : 0,
          ofrecen_cena_terceros: this.modelProveedor.ofrecen_cena_terceros ? 1 : 0,
          mascotas: this.modelProveedor.mascotas ? 1 : 0,
          venta_libre_canthabitaciones: this.modelProveedor.venta_libre
            ? (Number.isNaN(cantidadHabitaciones) ? null : cantidadHabitaciones)
            : null,
          picnic_tarifa: Number.isNaN(picnicTarifa) ? null : picnicTarifa,
          tarifas: tarifasPayload,
        };
        const esNuevoProveedor = !this.proveedorPersistido;

        if (esNuevoProveedor) {
          const modelProveedorCrearPayload = {
            ...modelProveedorPayload,
            nombre: modelProveedorPayload.nombre_alias,
            request_automatico: 0,
          };
          const proveedorCreado = await this.crearProveedor([
            this.access_token,
            modelProveedorCrearPayload,
          ]);

          if (proveedorCreado && proveedorCreado.id) {
            Object.assign(this.modelProveedor, {
              ...proveedorCreado,
              categoriaProveedor: this.modelProveedor.categoriaProveedor,
              punto: this.modelProveedor.punto,
              contactos: Array.isArray(proveedorCreado.contactos) ? proveedorCreado.contactos : this.modelProveedor.contactos,
              documentos: Array.isArray(proveedorCreado.documentos) ? proveedorCreado.documentos : this.modelProveedor.documentos,
              tarifas: Array.isArray(proveedorCreado.tarifas) ? proveedorCreado.tarifas : tarifasPayload,
            });
            this.tarifasAutoGeneradas = tarifasPayload.map(tarifa => ({
              ...tarifa,
              proveedor_id: proveedorCreado.id,
            }));
            this.setProveedorSelec(this.modelProveedor);
          }
        } else {
          await this.updateProveedor([
            this.access_token,
            modelProveedorPayload,
            this.regimenesSeleccionados,
            this.tiposHabitacionSeleccionados,
            this.caracteristicasHabitacionSeleccionadas,
            tarifasPayload,
          ]);
        }

        if (cerrar) {
          this._cerrarVentana();
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>


<style scoped>
.custom-tab {
  background-color: rgb(220, 220, 220) !important;
  border: 2px solid rgb(107, 107, 107) !important;
  
  border-radius: 4px !important;
  margin: 0 2px !important;
  transition: all 0.3s ease !important;
}

.active-tab {
  background-color: rgb(177, 216, 252) !important;
  color: #000 !important;
  font-weight: bold !important;
}

.v-tabs-slider {
  display: none !important;
  
}
</style>
